import React, { useState, useEffect, useContext } from "react"
import { Link } from "gatsby"
import axios from "axios"
import Img from "gatsby-image"
import { useTranslation } from "react-i18next"
import Rating from "@material-ui/lab/Rating"
import SiteContext from "../context/siteContext"

import { makeStyles, Grid, Typography, Button, Paper } from "@material-ui/core"

import SigninForm from "../components/signin-form"
import CartItemsBadge from "../components/header/cartItemsBadge"

import ShoppingCartIcon from "@material-ui/icons/ShoppingCart"
import BookImage from "../../static/images/book-image.png"

const windowGlobal = typeof window !== "undefined" && window

const useStyles = makeStyles(theme => ({
  bookItem: {
    margin: "0 auto",
    textAlign: "center",
    outlineWidth: 0,
    marginBottom: "1.5rem",
    "&:focus": {
      outlineWidth: 0,
    },
    "& *": {
      outlineWidth: 0,
      textAlign: "center",
      margin: "0 auto",
      textDecoration: "none",
    },
    "& img": {
      textAlign: "center",
      border: "3px solid #000",
      borderRadius: 10,
    },
    "& p": {
      maxWidth: 175,
      margin: "0 auto",
      fontSize: "1.2rem",
      color: "#003e96",
    },
    "& .add-to-cart-btn": {
      display: "none",
    },
    "& .rating-and-price": {
      marginTop: 1,
    },
    "&:hover .rating-and-price": {
      display: "none",
    },
    "&:hover .add-to-cart-btn": {
      display: "block",
    },
  },
  bookDetails: {
    color: "#092b5b !important",
    fontSize: "1rem !important",
  },
  addToCartBtn: {
    color: "#003e96",
    borderRadius: 10,
    marginTop: "1.1rem",
  },
  addToCartBtnIcon: {
    width: "1.5rem",
    height: "1.5rem",
    fontSize: "1.5rem",
  },
  outOfStock: {
    backgroundColor: "#003e96",
    width: 64,
    padding: 11,
    borderRadius: "50%",
    position: "absolute",
    right: "-30px",
    top: "-30px",
    color: "#fff",
    fontWeight: "600",
    zIndex: 9,
  },
  bookItemPaper: {
    position: "relative",
    backgroundColor: "transparent",
    border: 0,
    maxWidth: 175,
  },
  currencyIcon: {
    width: 14,
    marginBottom: "-2px",
    border: "0 !important",
    borderRadius: "0 !important",
  },
  bookImage: {
    width: 176,
    height: 244,
    float: "center",
    marginBottom: 12,
    objectFit: "cover",
  },
  bookImageForFixed: {
    marginBottom: 12,
  },
}))

const Books = ({ book, openSnackbar }) => {
  const classes = useStyles()
  const [t, i18n] = useTranslation()
  const [signFormOpen, setSignFormOpen] = useState(false)
  const [currencyRateState, setCurrencyRate] = useState(1)
  const [countItem] = useState({ count: 1 })
  const [newCartItem, setNewCartItem] = useState(false)
  const { isActiveCart, setIsActiveCart, setCartItemContentLenght } = useContext(SiteContext)

  useEffect(() => {
    if (windowGlobal) {
      if (windowGlobal.localStorage.getItem("currencyKey") === "TRY") {
        setCurrencyRate(windowGlobal.sessionStorage.getItem("currencyRate"))
      }
    }
  }, [])

  let jwtForProfile
  if (windowGlobal) {
    jwtForProfile = windowGlobal.sessionStorage.getItem("jwtCode")
  }
  let bookItems = book.book_items !== 0 ? book.book_items.filter(item => item.type === "paper") : ""
  let bookItem = bookItems.length > 0 ? bookItems[0] : {}
  const { type, price } = bookItem

  let bookPrice = price > 0 ? price : ""

  const signFormClose = () => {
    setSignFormOpen(false)
  }
  const handleOpenSnackbar = () => {
    openSnackbar()
  }

  const handleAddToCard = async () => {
    if (jwtForProfile) {
      await axios
        .post(
          `${process.env.GATSBY_API_URL}/add-cart-item`,
          {
            quantity: countItem.count,
            book: book.strapiId ? book.strapiId : book.id,
            format: "paper",
          },
          { headers: { Authorization: `Bearer ${jwtForProfile}` } }
        )
        .then(() => {
          handleOpenSnackbar()
          if (!isActiveCart) {
            setIsActiveCart(true)
          }
          axios
            .get(`${process.env.GATSBY_API_URL}/get-cart-items-by-type/paper`, {
              headers: {
                Authorization: `Bearer ${jwtForProfile}`,
              },
            })
            .then(res => {
              setCartItemContentLenght(res.data.items.length)
            })
        })
    } else {
      setSignFormOpen(true)
    }
    setNewCartItem(true)
  }

  return (
    <>
      <SigninForm isOpen={signFormOpen} onClose={signFormClose} />
      <CartItemsBadge isDisplay={false} countItem={newCartItem} />
      {i18n.language === "en" && book.title && (
        <Grid item xs={12} sm={6} lg={3} md={4} className={classes.bookItem}>
          <Paper variant="outlined" square className={classes.bookItemPaper}>
            {!book.quantity && <div className={classes.outOfStock}>{t("singleBook.outOfStock")}</div>}
            <Link to={`/${i18n.language}/books/${book.strapiId}`}>
              {book.image && !book.image.childImageSharp ? (
                <img src={book.image.publicURL} style={{ width: "169px", height: "244px" }} />
              ) : book.image.childImageSharp ? (
                // <Img fixed={book.image.childImageSharp.fixed} className={classes.bookImageForFixed} />
                <Img fixed={book.image.childImageSharp.fixed} className={classes.bookImageForFixed} />
              ) : (
                <img src={BookImage} alt={book.title} className={classes.bookImage} />
              )}
              <Typography variant="h5" component="p">
                {book.title}
              </Typography>
            </Link>
            <div className="rating-and-price">
              {book.rating ? (
                <Rating name="half-rating-read" defaultValue={book.rating} precision={0.5} readOnly />
              ) : (
                <Rating name="half-rating-read" defaultValue={0} precision={0.5} readOnly />
              )}
              <Typography className={classes.bookDetails}>
                {type && t("singleBook.type")}
                {bookPrice && t("singleBook.price") + " " + parseFloat(bookPrice * currencyRateState).toFixed(2)}
                {bookPrice && (currencyRateState > 1 ? <>&#8378;</> : <>&#36;</>)}
              </Typography>
            </div>
            <div className="add-to-cart-btn">
              <Button
                variant="contained"
                color="default"
                className={classes.addToCartBtn}
                onClick={handleAddToCard}
                disabled={!book.quantity && true}
                startIcon={<ShoppingCartIcon className={classes.addToCartBtnIcon} />}
              >
                {t("singleBook.addToCart")}
              </Button>
            </div>
          </Paper>
        </Grid>
      )}
      {i18n.language === "ar" && book.title_ar && (
        <Grid item xs={12} sm={6} lg={3} md={4} className={classes.bookItem}>
          <Paper variant="outlined" square className={classes.bookItemPaper}>
            {!book.quantity && <div className={classes.outOfStock}>{t("singleBook.outOfStock")}</div>}
            <Link to={`/${i18n.language}/books/${book.strapiId}`}>
              {book.image && !book.image.childImageSharp ? (
                <img src={book.image.publicURL} style={{ width: "169px", height: "244px" }} />
              ) : book.image && book.image.childImageSharp ? (
                // <Img fixed={book.image.childImageSharp.fixed} className={classes.bookImageForFixed} />
                <Img fixed={book.image.childImageSharp.fixed} className={classes.bookImageForFixed} />
              ) : (
                <img src={BookImage} alt={book.title} className={classes.bookImage} />
              )}
              <Typography variant="h5" component="p">
                {book.title_ar}
              </Typography>
            </Link>
            <div className="rating-and-price">
              {book.rating ? (
                <Rating name="half-rating-read" defaultValue={book.rating} precision={0.5} readOnly />
              ) : (
                <Rating name="half-rating-read" defaultValue={0} precision={0.5} readOnly />
              )}
              <Typography className={classes.bookDetails}>
                {type && t("singleBook.type")}{" "}
                {bookPrice && t("singleBook.price") + " " + parseFloat(bookPrice * currencyRateState).toFixed(2)}
                {bookPrice && (currencyRateState > 1 ? <>&#8378;</> : <>&#36;</>)}
              </Typography>
            </div>
            <div className="add-to-cart-btn">
              <Button
                variant="contained"
                color="default"
                className={classes.addToCartBtn}
                onClick={handleAddToCard}
                disabled={!book.quantity && true}
                startIcon={<ShoppingCartIcon className={classes.addToCartBtnIcon} />}
              >
                {t("singleBook.addToCart")}
              </Button>
            </div>
          </Paper>
        </Grid>
      )}
      {i18n.language === "tr" && book.title_tr && (
        <Grid item xs={12} sm={6} lg={3} md={4} className={classes.bookItem}>
          <Paper variant="outlined" square className={classes.bookItemPaper}>
            {!book.quantity && <div className={classes.outOfStock}>{t("singleBook.outOfStock")}</div>}
            <Link to={`/${i18n.language}/books/${book.strapiId}`}>
              {book.image && !book.image.childImageSharp ? (
                // <Img fixed={book.image.childImageSharp.fixed} className={classes.bookImageForFixed} />
                <img src={book.image.publicURL} style={{ width: "169px", height: "244px" }} />
              ) : 
              book.image.childImageSharp ? (
                <Img fixed={book.image.childImageSharp.fixed} className={classes.bookImageForFixed} />
              ) : (
                <img src={BookImage} alt={book.title} className={classes.bookImage} />
              )}
              <Typography variant="h5" component="p">
                {book.title_tr}
              </Typography>
            </Link>
            <div className="rating-and-price">
              {book.rating ? (
                <Rating name="half-rating-read" defaultValue={book.rating} precision={0.5} readOnly />
              ) : (
                <Rating name="half-rating-read" defaultValue={0} precision={0.5} readOnly />
              )}
              <Typography className={classes.bookDetails}>
                {type && t("singleBook.type")}{" "}
                {bookPrice && t("singleBook.price") + " " + parseFloat(bookPrice * currencyRateState).toFixed(2)}
                {bookPrice && (currencyRateState > 1 ? <>&#8378;</> : <>&#36;</>)}
              </Typography>
            </div>
            <div className="add-to-cart-btn">
              <Button
                variant="contained"
                color="default"
                className={classes.addToCartBtn}
                onClick={handleAddToCard}
                disabled={!book.quantity && true}
                startIcon={<ShoppingCartIcon className={classes.addToCartBtnIcon} />}
              >
                {t("singleBook.addToCart")}
              </Button>
            </div>
          </Paper>
        </Grid>
      )}
    </>
  )
}
export default Books
